import { useMutation } from "@tanstack/react-query";
import { createUsers as apiCreateUsers } from "../../api/apiUsers";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateUsers() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const {
        mutate: createUsers,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiCreateUsers(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            navigate('/users');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { isPending, error, createUsers, results };
}
